import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { FiPlus, FiMoreHorizontal } from "react-icons/fi";
import moment from 'moment';
import GroupStaffingLevelsEdit from "./GroupStaffingLevelEditModal";
import StaffingLevelEditModal, { STAFFING_LEVEL_MODAL_STYLE } from "components/StaffingLevels/StaffingLevelEditModal";
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as groupsActions from 'actions/groupsActions';
import { groupsService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from 'react-i18next';

class GroupStaffingLevels extends React.Component {
	constructor(props) {
		super(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewStaffingLevelModal = this.openNewStaffingLevelModal.bind(this);
		this.openEditStaffingLevelModal = this.openEditStaffingLevelModal.bind(this);
		this.openEditStaffingNeedModal = this.openEditStaffingNeedModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	componentDidMount() {
		this.getStaffingLevels();
		if (this.props.autoOpenCreateNeed) {
			this._autoOpenTimer = setTimeout(() => {
				this.openNewStaffingLevelModal({ fromAutoOpen: true });
			}, 80);
		}
	}

	componentWillUnmount() {
		if (this._autoOpenTimer) {
			clearTimeout(this._autoOpenTimer);
		}
	}

	async getStaffingLevels() {
		const groupId = this.props.group.id;
		await this.props.getGroupStaffingLevels(groupId);
	}

	closeModal() {
		this.props.hideModal()
	}

	notifyDataChanged() {
		if (typeof this.props.onDataChanged === "function") {
			this.props.onDataChanged();
		}
	}

	openNewStaffingLevelModal({ fromAutoOpen = false } = {}) {
		const { staffing_levels, group } = this.props;

		this.props.showModal({
			open: true,
			title: this.props.t('groups.staffing.newAssignment'),
			style: { width: '400px' },
			content: (
				<GroupStaffingLevelsEdit
					handleClose={this.closeModal}
					staffing_levels={staffing_levels}
					group_id={group.id}
					onDataChanged={this.props.onDataChanged}
				/>
			),
			closeModal: this.closeModal
		}, 'edit')
		if (!fromAutoOpen) {
			this.notifyDataChanged();
		}
	}

	openEditStaffingLevelModal(group_staffing_level) {
		const { staffing_levels, group } = this.props;

		this.props.showModal({
			open: true,
			title: this.props.t('groups.staffing.editAssignment'),
			style: { width: '400px' },
			content: (
				<GroupStaffingLevelsEdit
					group_staffing_level={group_staffing_level}
					group_id={group.id}
					handleClose={this.closeModal}
					staffing_levels={staffing_levels}
					onDataChanged={this.props.onDataChanged}
				/>
			),
			closeModal: this.closeModal
		}, 'edit')
	}

	openEditStaffingNeedModal(group_staffing_level) {
		this.props.showModal({
			open: true,
			title: this.props.t("staffingLevels.editModal"),
			style: STAFFING_LEVEL_MODAL_STYLE,
			content: (
				<StaffingLevelEditModal
					staffing_level={group_staffing_level.staffing_level}
					handleClose={this.closeModal}
					getStaffingLevels={this.handleStaffingNeedUpdated}
				/>
			),
			closeModal: this.closeModal,
		}, "edit")
	}

	handleStaffingNeedUpdated = () => {
		this.props.getSelectableStaffingLevels();
		this.getStaffingLevels();
		this.notifyDataChanged();
	}

	openDeleteStaffingLevelModal(idStaffingLevel) {
		this.props.showModal({
			open: true,
			title: this.props.t('groups.staffing.deleteAssignment'),
			style: { width: '350px' },
			message: this.props.t('groups.staffing.deleteConfirmation'),
			deleteAction: () => this.confirmDelete(idStaffingLevel),
			closeModal: this.closeModal
		}, 'delete')
	}

	openAlertModal(message) {
		this.props.showModal({
			open: true,
			title: this.props.t('groups.deleteError'),
			style: { width: '400px' },
			message: message,
			closeModal: this.closeModal
		}, 'alert')
	}

	confirmDelete = async (idStaffingLevel) => {
		const response = await groupsService.removeStaffingLevel(this.props.group.id, idStaffingLevel);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		}
		else {
			this.getStaffingLevels();
			this.closeModal();
			this.notifyDataChanged();
		}
	}

	formatDay = (value) => (value ? moment(value).format("DD/MM/YY") : "-");

	getColumns = () => {
		const isDrawer = this.props.variant === "drawer";
		return [
			{
				key: "need",
				header: isDrawer
					? this.props.t("groups.staffing.columnNeed")
					: this.props.t("groups.staffing.staffingLevel"),
				sortAccessor: (row) => row.staffing_level?.name || "",
				render: (group_needs) => (
					<button
						type="button"
						className="btn-transparent btn-editable"
						onClick={() => this.openEditStaffingLevelModal(group_needs)}
					>
						{group_needs.staffing_level.name}
					</button>
				),
			},
			{
				key: "start",
				header: this.props.t("groups.staffing.columnStart"),
				sortAccessor: (row) => row.start_day || "",
				render: (group_needs) => this.formatDay(group_needs.start_day),
			},
			{
				key: "end",
				header: this.props.t("groups.staffing.columnEnd"),
				sortAccessor: (row) => row.end_day || "",
				render: (group_needs) => this.formatDay(group_needs.end_day),
			},
		];
	};

	renderActions = (group_needs) => {
		const isDrawer = this.props.variant === "drawer";

		return (
		<Dropdown>
			<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item as="button" onClick={() => this.openEditStaffingLevelModal(group_needs)}>
					{isDrawer ? this.props.t('groups.staffing.modifyAssignmentAction') : this.props.t('common.edit')}
				</Dropdown.Item>
				{isDrawer && (
					<Dropdown.Item as="button" onClick={() => this.openEditStaffingNeedModal(group_needs)}>
						{this.props.t('groups.staffing.editNeedAction')}
					</Dropdown.Item>
				)}
				<Dropdown.Item as="button" onClick={() => this.openDeleteStaffingLevelModal(group_needs.id)}>{this.props.t('common.delete')}</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
		);
	};

	getContent = () => {
		const { group_staffing_levels } = this.props;
		const isDrawer = this.props.variant === "drawer";
		const rows = group_staffing_levels || [];

		return (
			<>
				{isDrawer && (
					<div className="group-staffing-levels-toolbar">
						<button
							type="button"
							className="btn btn-primary group-staffing-levels-toolbar__btn"
							onClick={this.openNewStaffingLevelModal}
						>
							<FiPlus /> {this.props.t("groups.staffing.newNeed")}
						</button>
					</div>
				)}
				<DataTable
					tableClassName="table-groups table-groups-staffing-levels table-hover"
					tableStyle={{ backgroundColor: "#ffffff" }}
					columns={this.getColumns()}
					rows={rows}
					rowKey={(row) => row.id}
					emptyMessage={this.props.t('groups.staffing.noStaffingLevels')}
					actionsColumn={{
						render: this.renderActions,
						className: "td-actions",
						header: !isDrawer ? (
							<button
								type="button"
								title={this.props.t("groups.staffing.assignTitle")}
								onClick={this.openNewStaffingLevelModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
						) : null,
					}}
				/>
			</>
		);
	}

	render() {
		return (
			<>
				{this.getContent()}
			</>
		)
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
	}
};

const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
	getGroupStaffingLevels: (id) => dispatch(groupsActions.getGroupStaffingLevels(id)),
	getSelectableStaffingLevels: () => dispatch(groupsActions.getSelectableStaffingLevels())
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GroupStaffingLevels));
